import PropTypes from 'prop-types'

// MOK
import Select from '../../../../Select/Select'

// import Tooltip from "../Tooltip/Tooltip"

// import { SelectionLabel } from "../DimensionSelect.styles"

const SelectBox = ({
  id,
  name,
  description,
  selectedValue,
  handleSelect,
  values,
  language,
  renderCorrectionInformation,
}) => (
  /* <div className="lfc-select-container">
    <SelectionLabel htmlFor={id}>{name}</SelectionLabel>

    {description && <Tooltip content={description} />}

    <select id={id} value={selectedValue} onChange={handleSelect}>
      {values.map((value) => (
        <option
          key={"dv".concat(value.valueId.toString())}
          value={value.valueId}
          disabled={!value.selectable}
        >
          {value[`valueName${language}`]}
        </option>
      ))}
    </select>

    {renderCorrectionInformation && renderCorrectionInformation()} */

  /* MOK */
  <>
    <Select
      id={id}
      value={selectedValue}
      onChange={handleSelect}
      options={values.map(({ valueId, selectable }) => ({
        key: valueId,
        value: valueId,
        disabled: !selectable,
      }))}
      formatterForOption={(value) => values.find((valObj) => valObj.valueId === value)[`valueName${language}`]}
      label={name}
      dangerouslySetInfo={description}
    />

    {renderCorrectionInformation && renderCorrectionInformation()}
  </>
)
// </div>

SelectBox.defaultProps = {
  description: '',
  renderCorrectionInformation: null,
}

SelectBox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  selectedValue: PropTypes.string.isRequired,
  handleSelect: PropTypes.func.isRequired,
  values: PropTypes.array.isRequired,
  language: PropTypes.string.isRequired,
  renderCorrectionInformation: PropTypes.func,
}

export default SelectBox
